/* Dirty South Tease — global runtime (loaded on every page).
   Provides: DST.announce (live region), DST.Dialog (focus-trapped modals), DST.fetchSections,
   DST.cart (serialized Cart API with section rendering), DST.store (device-local lists),
   header/drawer/dock behaviour and card-level controls (wishlist, compare, quick add/shop). */
(function () {
  'use strict';
  if (window.DST && window.DST.__ready) return; // never double-initialise (theme editor reloads)
  var DST = window.DST = window.DST || {};
  DST.__ready = true;
  var cfg = DST.config || {};

  /* ---------- Live region ---------- */
  var live = document.getElementById('dst-live');
  DST.announce = function (msg, assertive) {
    if (!live) return;
    live.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  };

  /* ---------- Toast ---------- */
  DST.toast = function (msg) {
    var t = document.getElementById('dst-toast');
    if (!t) return;
    t.textContent = msg; t.hidden = false; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.hidden = true; }, 300); }, 2600);
  };

  /* ---------- Scroll lock ---------- */
  var locks = 0;
  DST.lockScroll = function (on) {
    locks = Math.max(0, locks + (on ? 1 : -1));
    document.documentElement.classList.toggle('dst-locked', locks > 0);
  };

  /* ---------- Dialogs (focus trap, Escape, focus return) ---------- */
  var FOCUSABLE = 'a[href],area[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),iframe,audio[controls],video[controls],[tabindex]:not([tabindex="-1"])';
  function Dialog(el) {
    this.el = el; this.opener = null; var self = this;
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); self.close(); }
      if (e.key === 'Tab') {
        var f = Array.prototype.filter.call(el.querySelectorAll(FOCUSABLE), function (n) { return n.offsetParent !== null || n === document.activeElement; });
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-dialog-close]') || e.target === el.querySelector('[data-dialog-overlay]')) self.close();
    });
  }
  Dialog.prototype.open = function (opener) {
    if (this.isOpen) return;
    this.opener = opener || document.activeElement;
    clearTimeout(this.hideTimer); this.hideTimer = null;
    this.el.hidden = false; this.el.setAttribute('aria-hidden', 'false');
    var self = this; requestAnimationFrame(function () { self.el.classList.add('is-open'); });
    this.isOpen = true; DST.lockScroll(true);
    var target = this.el.querySelector('[data-autofocus]') || this.el.querySelector(FOCUSABLE) || this.el;
    setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }, 40);
    this.el.dispatchEvent(new CustomEvent('dialog:open'));
  };
  Dialog.prototype.close = function () {
    if (!this.isOpen) return;
    var self = this; this.isOpen = false;
    this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true');
    this.hideTimer = setTimeout(function () { if (!self.isOpen) self.el.hidden = true; }, 260);
    DST.lockScroll(false);
    this.el.querySelectorAll('video, audio').forEach(function (m) { try { m.pause(); } catch (e) {} });
    if (this.opener && document.contains(this.opener)) { try { this.opener.focus({ preventScroll: true }); } catch (e) {} }
    this.el.dispatchEvent(new CustomEvent('dialog:close'));
  };
  DST.Dialog = Dialog;
  DST.dialogs = {};
  DST.dialog = function (id) {
    var el = document.getElementById(id);
    if (!el) return null;
    if (!DST.dialogs[id]) DST.dialogs[id] = new Dialog(el);
    return DST.dialogs[id];
  };
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || e.defaultPrevented) return;
    var open = Object.keys(DST.dialogs).map(function (k) { return DST.dialogs[k]; }).filter(function (d) { return d && d.isOpen; });
    if (open.length && !open[open.length - 1].el.contains(e.target)) open[open.length - 1].close();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-dialog]');
    if (!t) return;
    var d = DST.dialog(t.getAttribute('data-open-dialog'));
    if (d) { e.preventDefault(); d.open(t); }
  });

  /* ---------- Fetch helpers ---------- */
  DST.parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
  DST.fetchSection = function (url, sectionId, signal) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { signal: signal, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
  };
  DST.formatMoney = function (cents, format) {
    format = format || cfg.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  };

  /* ---------- Cart API: serialized, section-rendered ---------- */
  var queue = Promise.resolve();
  function cartSections() {
    var ids = [];
    document.querySelectorAll('[data-cart-section]').forEach(function (n) { var id = n.getAttribute('data-cart-section'); if (ids.indexOf(id) < 0) ids.push(id); });
    return ids.slice(0, 5);
  }
  var FOCUS_ATTRS = ['data-line-step', 'data-line-remove', 'data-line-qty', 'data-discount-apply', 'data-discount-input', 'data-discount-remove', 'data-checkout-button', 'data-cart-note'];
  function focusSignature() {
    var a = document.activeElement; if (!a || a === document.body) return null;
    var line = a.closest('[data-line-key]');
    for (var i = 0; i < FOCUS_ATTRS.length; i++) if (a.hasAttribute(FOCUS_ATTRS[i])) return { attr: FOCUS_ATTRS[i], val: a.getAttribute(FOCUS_ATTRS[i]), line: line && line.getAttribute('data-line-key'), dialog: a.closest('.dialog') };
    return { dialog: a.closest('.dialog'), id: a.id };
  }
  function restoreFocus(sig) {
    if (!sig || (document.activeElement && document.activeElement !== document.body && document.contains(document.activeElement))) return;
    var scope = sig.dialog || document, el = null;
    if (sig.attr) {
      var sel = '[' + sig.attr + (sig.val ? '="' + sig.val.replace(/"/g, '\\"') + '"' : '') + ']';
      el = sig.line ? scope.querySelector('[data-line-key="' + sig.line + '"] ' + sel) : scope.querySelector(sel);
      if (!el && sig.line) { var lines = scope.querySelectorAll('[data-line-key]'); el = lines.length ? lines[0].querySelector('[data-line-qty]') : null; }
    }
    if (!el && sig.id) el = document.getElementById(sig.id);
    if (!el && sig.dialog) el = sig.dialog.querySelector('.drawer__head .h3, h2, [data-dialog-close]');
    if (el) { if (!el.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) el.setAttribute('tabindex', '-1'); try { el.focus({ preventScroll: true }); } catch (e) {} }
  }
  function renderSections(sections) {
    if (!sections || typeof sections !== 'object') return false;
    var sig = focusSignature(), required = cartSections(), complete = required.length > 0;
    required.forEach(function (id) { if (!sections[id]) complete = false; });
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = DST.parseHTML(html);
      document.querySelectorAll('[data-cart-section="' + id + '"]').forEach(function (target) {
        var key = target.getAttribute('data-cart-part') || '';
        var src = key ? doc.querySelector('[data-cart-section="' + id + '"][data-cart-part="' + key + '"]') : doc.querySelector('[data-cart-section="' + id + '"]');
        if (src) target.innerHTML = src.innerHTML; else complete = false;
      });
    });
    restoreFocus(sig);
    document.dispatchEvent(new CustomEvent('cart:rendered'));
    return complete;
  }
  function cartStale(on) {
    if (DST.cart) DST.cart.viewStale = on;
    document.querySelectorAll('[data-cart-root]').forEach(function (root) {
      var old = root.querySelector('[data-cart-sync-error]'); if (old) old.remove();
      if (!on) return;
      var note = document.createElement('p'); note.className = 'form-message form-message--error'; note.setAttribute('data-cart-sync-error', ''); note.setAttribute('role', 'alert'); note.textContent = 'The bag changed, but this view could not refresh. ';
      var link = document.createElement('a'); link.href = (cfg.routes && cfg.routes.cart) || '/cart'; link.textContent = 'Open your full bag before checkout.'; note.appendChild(link); root.prepend(note);
    });
    document.dispatchEvent(new CustomEvent('cart:sync-state'));
  }
  function refreshCartSections() {
    var ids = cartSections(); if (!ids.length) return Promise.resolve(true);
    var u = new URL((cfg.routes && cfg.routes.cart) || '/cart', window.location.origin); u.searchParams.set('sections', ids.join(','));
    return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('Could not refresh the bag.'); return r.json(); }).then(function (sections) { if (!renderSections(sections)) throw new Error('Missing bag sections.'); return true; });
  }
  function request(path, body) {
    var job = queue.then(function () {
      var isForm = typeof FormData !== 'undefined' && body instanceof FormData, init;
      if (isForm) {
        // Multipart (file uploads for personalization): Shopify stores the files and returns the line item.
        body.set('sections', cartSections().join(',')); body.set('sections_url', window.location.pathname);
        init = { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body };
      } else {
        var payload = Object.assign({}, body, { sections: cartSections().join(','), sections_url: window.location.pathname });
        init = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) };
      }
      return fetch((cfg.routes && cfg.routes.root ? cfg.routes.root.replace(/\/$/, '') : '') + path, init).then(function (r) {
        return r.json().catch(function () { throw new Error('We couldn’t confirm the bag update. Open your bag to check it before trying again.'); }).then(function (data) {
          if (!r.ok || data.status) {
            var err = new Error(data.description || data.message || (cfg.strings && cfg.strings.cartError) || 'Something went wrong. Please try again.');
            err.status = r.status; throw err;
          }
          if (isForm && data && typeof data === 'object' && !Array.isArray(data) && !Array.isArray(data.items) && data.variant_id) data = Object.assign({ items: [data] }, data);
          if (!data || typeof data !== 'object' || Array.isArray(data) || !Array.isArray(data.items) || (path !== '/cart/add.js' && typeof data.item_count !== 'number')) throw new Error('We couldn’t confirm the bag update. Open your bag before trying again.');
          if (renderSections(data.sections)) { cartStale(false); return data; }
          cartStale(true);
          return refreshCartSections().then(function () { cartStale(false); return data; }).catch(function () { cartStale(true); DST.announce('Your bag changed, but this view is unavailable. Open the full bag before checkout.', true); return data; });
        });
      });
    });
    queue = job.catch(function () {});
    return job;
  }
  DST.cart = {
    add: function (items) { return request('/cart/add.js', { items: items }); },
    addForm: function (formData) { return request('/cart/add.js', formData); },
    change: function (key, quantity) { return request('/cart/change.js', { id: key, quantity: quantity }); },
    update: function (data) { return request('/cart/update.js', data); },
    viewStale: false,
    refresh: function () {
      return queue.then(function () { return refreshCartSections(); }).then(function () { cartStale(false); return true; }).catch(function () { cartStale(true); DST.announce('We couldn’t refresh this bag view. Open the full bag before checkout.', true); return false; });
    },
    open: function (opener) {
      if (DST.cart.viewStale) return false;
      if (cfg.cartType === 'drawer') { var d = DST.dialog('CartDrawer'); if (d) { d.open(opener); return true; } }
      return false;
    }
  };
  DST.renderSections = renderSections;

  /* ---------- Device-local lists (wishlist / compare / recently viewed) ---------- */
  function readList(key) { try { var v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeList(key, list) { try { localStorage.setItem(key, JSON.stringify(list)); return true; } catch (e) { return false; } }
  DST.store = {
    get: readList,
    has: function (key, handle) { return readList(key).indexOf(handle) > -1; },
    toggle: function (key, handle, max) {
      var list = readList(key), i = list.indexOf(handle), added;
      if (i > -1) { list.splice(i, 1); added = false; }
      else { if (max && list.length >= max) return null; list.unshift(handle); added = true; }
      writeList(key, list); document.dispatchEvent(new CustomEvent('dst:list', { detail: { key: key } }));
      return added;
    },
    remove: function (key, handle) { var l = readList(key).filter(function (h) { return h !== handle; }); writeList(key, l); document.dispatchEvent(new CustomEvent('dst:list', { detail: { key: key } })); },
    push: function (key, handle, max) { var l = readList(key).filter(function (h) { return h !== handle; }); l.unshift(handle); writeList(key, l.slice(0, max || 12)); },
    clear: function (key) { writeList(key, []); document.dispatchEvent(new CustomEvent('dst:list', { detail: { key: key } })); }
  };
  var WL = 'dst_wishlist', CMP = 'dst_compare';

  function syncListUI() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = DST.store.has(WL, b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.getAttribute(on ? 'data-label-remove' : 'data-label-add');
      if (label) { b.setAttribute('aria-label', label); var t = b.querySelector('[data-label]'); if (t) t.textContent = label; }
    });
    document.querySelectorAll('[data-compare-toggle]').forEach(function (b) {
      var on = DST.store.has(CMP, b.getAttribute('data-handle'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var wc = DST.store.get(WL).length, cc = DST.store.get(CMP).length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (n) { n.textContent = wc; n.hidden = wc === 0; });
    document.querySelectorAll('[data-compare-count]').forEach(function (n) { n.textContent = cc; });
    var tray = document.getElementById('CompareTray');
    if (tray) { tray.hidden = cc === 0; }
  }
  DST.syncListUI = syncListUI;
  document.addEventListener('dst:list', syncListUI);
  document.addEventListener('cart:rendered', syncListUI);

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault();
      var added = DST.store.toggle(WL, w.getAttribute('data-handle'));
      var name = w.getAttribute('data-title') || 'Item';
      DST.announce(added ? name + ' saved to your favorites on this device.' : name + ' removed from your favorites.');
      DST.toast(added ? 'Saved to favorites' : 'Removed from favorites');
      return;
    }
    var c = e.target.closest('[data-compare-toggle]');
    if (c) {
      e.preventDefault();
      var res = DST.store.toggle(CMP, c.getAttribute('data-handle'), 3);
      if (res === null) { DST.announce('You can compare up to three products. Remove one to add another.', true); DST.toast('Compare holds up to 3 products'); return; }
      DST.announce(res ? 'Added to compare.' : 'Removed from compare.');
      return;
    }
    var clr = e.target.closest('[data-compare-clear]');
    if (clr) { DST.store.clear(CMP); DST.announce('Compare list cleared.'); }
  });

  /* ---------- Card color swatches: update image + links, keep selection state ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-card]');
    card.querySelectorAll('[data-card-swatch]').forEach(function (b) { b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'); });
    var url = sw.getAttribute('data-url');
    card.querySelectorAll('[data-card-link]').forEach(function (a) { a.href = url; });
    var qs = card.querySelector('[data-quick-shop]'); if (qs) qs.setAttribute('data-url', url);
    var img = card.querySelector('[data-card-image]'), src = sw.getAttribute('data-image');
    if (img && src) { img.removeAttribute('srcset'); img.src = src; }
  });

  /* ---------- Quick add (single available variant only) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-quick-add]');
    if (!form || cfg.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    DST.announce(cfg.strings.adding || 'Adding to bag…');
    DST.cart.add([{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }]).then(function () {
      DST.announce((form.getAttribute('data-title') || 'Item') + ' ' + (cfg.strings.added || 'added to your bag.'));
      if (!DST.cart.open(btn)) window.location.href = (cfg.routes && cfg.routes.cart) || '/cart';
    }).catch(function (err) {
      DST.announce(err.message, true); DST.toast(err.message);
    }).then(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
  });

  /* ---------- Quick shop: request ownership, product DOM IDs and controller lifecycle ---------- */
  var quickRequest = 0, quickController = null;
  DST.namespaceProduct = function (root, prefix) {
    var map = Object.create(null);
    root.querySelectorAll('[id]').forEach(function (n) { var old = n.id; if (!old) return; map[old] = prefix + old; n.id = map[old]; });
    ['for', 'form', 'aria-controls', 'aria-labelledby', 'aria-describedby', 'aria-owns', 'data-open-dialog'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (n) { n.setAttribute(attr, n.getAttribute(attr).split(/\s+/).map(function (id) { return map[id] || id; }).join(' ')); });
    });
    root.querySelectorAll('a[href^="#"]').forEach(function (n) { var id = n.getAttribute('href').slice(1); if (map[id]) n.setAttribute('href', '#' + map[id]); });
    root.setAttribute('data-dom-prefix', prefix);
  };
  function disposeQuickProduct(body) {
    body.querySelectorAll('[data-product-section]').forEach(function (n) { if (n.__dstProduct && n.__dstProduct.destroy) n.__dstProduct.destroy(); });
    Object.keys(DST.dialogs).forEach(function (id) { var d = DST.dialogs[id]; if (id !== 'QuickShop' && body.contains(d.el)) { d.close(); clearTimeout(d.hideTimer); delete DST.dialogs[id]; } });
  }
  document.addEventListener('dialog:close', function (e) {
    if (e.target.id !== 'QuickShop') return;
    quickRequest++; if (quickController) quickController.abort();
    var body = document.getElementById('QuickShopBody'); if (body) disposeQuickProduct(body);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-shop]'); if (!b) return;
    var dlg = DST.dialog('QuickShop'); if (!dlg) return;
    e.preventDefault();
    var body = document.getElementById('QuickShopBody'), requestId = ++quickRequest;
    if (quickController) quickController.abort(); quickController = new AbortController();
    var url; try { url = new URL(b.getAttribute('data-url'), window.location.origin); if (url.origin !== window.location.origin) throw new Error('origin'); } catch (err) { DST.announce('This product link is unavailable.', true); return; }
    disposeQuickProduct(body);
    body.textContent = ''; var loading = document.createElement('p'); loading.className = 'loading-state'; loading.setAttribute('role', 'status'); loading.textContent = cfg.strings.loading || 'Loading…'; body.appendChild(loading);
    dlg.open(b);
    fetch(url.toString(), { signal: quickController.signal, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      if (requestId !== quickRequest || !dlg.isOpen) return;
      var doc = DST.parseHTML(html), sec = doc.querySelector('[data-product-section]'); if (!sec) throw new Error('missing');
      sec.querySelectorAll('.breadcrumbs, [data-sticky-buy], [data-lightbox], script[type="application/ld+json"], .product__description, [data-quick-hide]').forEach(function (n) { n.remove(); });
      DST.namespaceProduct(sec, 'Quick-' + requestId + '-');
      var h1 = sec.querySelector('h1'); if (h1) { var h2 = document.createElement('h2'); h2.className = 'h1 product__title'; var link = document.createElement('a'); link.href = url.toString(); link.textContent = h1.textContent; h2.appendChild(link); h1.replaceWith(h2); }
      sec.classList.add('product--quick-wrap'); body.textContent = ''; body.appendChild(document.importNode(sec, true));
      var full = document.createElement('a'); full.className = 'link-button quick-full'; full.href = url.toString(); full.textContent = (cfg.strings.viewProduct || 'View full details'); body.appendChild(full);
      document.dispatchEvent(new CustomEvent('dst:product-form-mounted', { detail: { root: body } }));
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (err) {} }
      var h = body.querySelector('h2'); if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    }).catch(function (err) {
      if (err.name === 'AbortError' || requestId !== quickRequest || !dlg.isOpen) return;
      body.textContent = ''; var message = document.createElement('p'); message.className = 'form-message form-message--error'; message.setAttribute('role', 'alert'); message.textContent = (cfg.strings.quickShopError || 'We couldn’t load this product here.') + ' ';
      var link = document.createElement('a'); link.href = url.toString(); link.textContent = cfg.strings.viewProduct || 'View full details'; message.appendChild(link); body.appendChild(message);
    });
  });

  /* ---------- Header: mega menu & drawer ---------- */
  function initHeader() {
    // Disclosure-based mega menu: click/Enter/Space toggles, Escape closes, hover is an enhancement only.
    document.querySelectorAll('[data-mega]').forEach(function (item) {
      var btn = item.querySelector('[data-mega-toggle]'), panel = item.querySelector('[data-mega-panel]');
      if (!btn || !panel) return;
      function set(open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); panel.hidden = !open; item.classList.toggle('is-open', open); }
      var hoverOpenedAt = 0;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        if (!open && Date.now() - hoverOpenedAt < 600) open = true; // a click right after hover-open keeps it open
        document.querySelectorAll('[data-mega] [data-mega-toggle][aria-expanded="true"]').forEach(function (o) { if (o !== btn) o.click(); });
        set(open);
      });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { set(false); btn.focus(); } });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) set(false); });
      if (window.matchMedia('(hover: hover)').matches) {
        var t; item.addEventListener('mouseenter', function () { clearTimeout(t); if (btn.getAttribute('aria-expanded') !== 'true') hoverOpenedAt = Date.now(); set(true); });
        item.addEventListener('mouseleave', function () { t = setTimeout(function () { set(false); }, 160); });
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mega]')) document.querySelectorAll('[data-mega] [data-mega-toggle][aria-expanded="true"]').forEach(function (b) { b.click(); });
    });
    // Header height for sticky offsets / anchored headings
    var header = document.querySelector('[data-site-header]');
    var announcement = document.getElementById('shopify-section-announcement-bar');
    function setH() {
      if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
      var topHeight = (header ? header.getBoundingClientRect().height : 0) + (announcement ? announcement.getBoundingClientRect().height : 0);
      document.documentElement.style.setProperty('--dst-top-h', topHeight + 'px');
    }
    setH(); window.addEventListener('resize', setH, { passive: true });
    if (window.ResizeObserver) {
      var topObserver = new ResizeObserver(setH);
      if (header) topObserver.observe(header);
      if (announcement) topObserver.observe(announcement);
    }
    if (header) header.classList.remove('is-hidden');
  }

  /* ---------- Mobile dock & sticky bars yield to the on-screen keyboard ---------- */
  function initKeyboardYield() {
    if (!window.visualViewport) return;
    var vv = window.visualViewport;
    vv.addEventListener('resize', function () {
      var kb = window.innerHeight - vv.height > 150;
      document.documentElement.classList.toggle('dst-keyboard', kb);
    });
  }

  /* ---------- Ticker pause ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ticker-toggle]');
    if (!b) return;
    var t = b.closest('.dst-ticker'); var paused = t.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', paused ? 'true' : 'false');
    b.setAttribute('aria-label', paused ? 'Play scrolling text' : 'Pause scrolling text');
  });

  /* ---------- Scheduled content (client-side guard; Liquid also gates) ---------- */
  function initSchedules() {
    var now = Date.now();
    document.querySelectorAll('[data-schedule-start], [data-schedule-end]').forEach(function (el) {
      if (el.hasAttribute('data-design-mode')) return;
      var s = Date.parse(el.getAttribute('data-schedule-start') || ''), en = Date.parse(el.getAttribute('data-schedule-end') || '');
      if ((s && now < s) || (en && now >= en)) el.hidden = true;
    });
  }

  /* ---------- Share ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-share]');
    if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('data-url') || window.location.href;
    var title = b.getAttribute('data-title') || document.title;
    if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
    var done = function () { DST.announce(cfg.strings.linkCopied || 'Link copied.'); DST.toast(cfg.strings.linkCopied || 'Link copied'); };
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copy this link', url); });
    else window.prompt('Copy this link', url);
  });

  /* ---------- Copy buttons (gift card codes etc.) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b || !navigator.clipboard) return;
    navigator.clipboard.writeText(b.getAttribute('data-copy')).then(function () { DST.announce('Copied.'); DST.toast('Copied'); });
  });

  function init() {
    initHeader(); initKeyboardYield(); initSchedules(); syncListUI();
    document.querySelectorAll('[data-open-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (DST.cart.open(a)) e.preventDefault(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Hover zoom (v3.5, shared since v3.7.4): on desktop, hovering a product photo, a matching-set piece or a look photo
   magnifies it under the cursor. Clicking still does what the element does (lightbox or product link).
   Off for touch screens and reduced motion. */
(function () {
  if (window.DSTHoverZoom) return; window.DSTHoverZoom = true;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  function pos(btn, e) {
    var r = btn.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, (e.clientX - r.left) / r.width * 100));
    var y = Math.min(100, Math.max(0, (e.clientY - r.top) / r.height * 100));
    btn.style.setProperty('--zx', x + '%'); btn.style.setProperty('--zy', y + '%');
  }
  document.addEventListener('pointerover', function (e) {
    if (!fine.matches || calm.matches || e.pointerType === 'touch') return;
    var btn = e.target.closest && e.target.closest('.product__zoom, [data-hover-zoom]');
    if (!btn || btn.classList.contains('is-zooming')) return;
    var img = btn.querySelector('img'); if (!img) return;
    if (!img.dataset.zoomReady) { img.dataset.zoomReady = '1'; if (img.srcset) img.sizes = Math.min(2000, Math.round(btn.getBoundingClientRect().width * 2.4 * (window.devicePixelRatio || 1))) + 'px'; }
    pos(btn, e); btn.classList.add('is-zooming');
  });
  document.addEventListener('pointermove', function (e) {
    var btn = e.target.closest && e.target.closest('.is-zooming');
    if (btn) pos(btn, e);
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    var btn = e.target.closest && e.target.closest('.is-zooming');
    if (btn && !btn.contains(e.relatedTarget)) btn.classList.remove('is-zooming');
  });
})();

